import placeholder from "../../assets/tour/placeholder.svg";
import flowsIntro from "../../assets/tour/flows/intro.png";
import flows1 from "../../assets/tour/flows/step-01.svg";
import flows2 from "../../assets/tour/flows/step-02.svg";
import flows3 from "../../assets/tour/flows/step-03.svg";
import flows4 from "../../assets/tour/flows/step-04.svg";
import popupsIntro from "../../assets/tour/popups/intro.png";
import popups1 from "../../assets/tour/popups/step-01.svg";
import popups2 from "../../assets/tour/popups/step-02.svg";
import popups3 from "../../assets/tour/popups/step-03.svg";
import popups4 from "../../assets/tour/popups/step-04.svg";
import popups5 from "../../assets/tour/popups/step-05.svg";
import chatsIntro from "../../assets/tour/chats/intro.png";
import chats1 from "../../assets/tour/chats/step-01.svg";
import chats2 from "../../assets/tour/chats/step-02.svg";
import chats3 from "../../assets/tour/chats/step-03.svg";
import chats4 from "../../assets/tour/chats/step-04.svg";
import chats5 from "../../assets/tour/chats/step-05.svg";
import reviewsIntro from "../../assets/tour/reviews/intro.png";
import reviews1 from "../../assets/tour/reviews/step-01.svg";
import reviews2 from "../../assets/tour/reviews/step-02.svg";
import reviews3 from "../../assets/tour/reviews/step-03.svg";
import reviews4 from "../../assets/tour/reviews/step-04.svg";
import reviews5 from "../../assets/tour/reviews/step-05.svg";
import wishlistsIntro from "../../assets/tour/wishlists/intro.png";
import wishlists1 from "../../assets/tour/wishlists/step-01.svg";
import wishlists2 from "../../assets/tour/wishlists/step-02.svg";
import wishlists3 from "../../assets/tour/wishlists/step-03.svg";
import wishlists4 from "../../assets/tour/wishlists/step-04.svg";
import wishlists5 from "../../assets/tour/wishlists/step-05.svg";
import campaignIntro from "../../assets/tour/campaign/intro.png";
import campaign1 from "../../assets/tour/campaign/step-01.svg";
import campaign2 from "../../assets/tour/campaign/step-02.svg";
import campaign3 from "../../assets/tour/campaign/step-03.svg";
import campaign4 from "../../assets/tour/campaign/step-04.svg";
import campaign5 from "../../assets/tour/campaign/step-05.svg";
import type {
  EwTourStep,
  ProductTourId,
  TourDefinition,
  TourMedia,
  TourSegment,
} from "./types";

const img = (src: string): TourMedia => ({ type: "image", src });
// ponytail: stills only; drop .gif at same path and flip type to "gif" later.

function mediaAt(media: TourMedia[], index: number): TourMedia {
  return media[index] || media[media.length - 1];
}

function step(
  target: string,
  titleKey: string,
  bodyKey: string,
  media: TourMedia,
  extra: Partial<EwTourStep["data"]> = {},
  placement: EwTourStep["placement"] = "bottom"
): EwTourStep {
  return {
    target,
    disableBeacon: true,
    placement,
    data: {
      titleKey,
      bodyKey,
      media,
      ...extra,
    },
  };
}

function segment(route: string, steps: EwTourStep[]): TourSegment {
  return { route, steps };
}

function popupEditorRoute(): string | null {
  if (/\/popups\/edit\//.test(window.location.pathname)) {
    return window.location.pathname + window.location.search;
  }
  const link = document.querySelector(
    'a.popup-list__thumb-link[href*="/popups/edit/"]'
  ) as HTMLAnchorElement | null;
  return link?.getAttribute("href") || null;
}

function latestCampaignDraftRoute(): string | null {
  const link = document.querySelector(
    'a[href*="/email/campaigns/"][href*="/view/"]'
  ) as HTMLAnchorElement | null;
  return link?.getAttribute("href") || null;
}

function flowSegments(media: TourMedia[]): TourSegment[] {
  return [
    segment("/email/automations", [
      step(
        '[data-ew-tour="flows-list"]',
        "flows.steps.list.title",
        "flows.steps.list.body",
        mediaAt(media, 0),
        {
          eyebrowKey: "common.eyebrow",
          requiresSelector: '[data-ew-tour="flows-list"]',
        }
      ),
      step(
        '[data-ew-tour="flows-import"]',
        "flows.steps.import.title",
        "flows.steps.import.body",
        mediaAt(media, 1),
        { requiresSelector: '[data-ew-tour="flows-import"]' }
      ),
      step(
        '[data-tut="reactour__create_automations"]',
        "flows.steps.create.title",
        "flows.steps.create.body",
        mediaAt(media, 2),
        { requiresSelector: '[data-tut="reactour__create_automations"]' }
      ),
      step(
        '[data-ew-tour="flows-stats"]',
        "flows.steps.stats.title",
        "flows.steps.stats.body",
        mediaAt(media, 3),
        { requiresSelector: '[data-ew-tour="flows-stats"]' }
      ),
      step(
        '[data-ew-tour="flows-status"]',
        "flows.steps.status.title",
        "flows.steps.status.body",
        mediaAt(media, 4),
        { requiresSelector: '[data-ew-tour="flows-status"]' },
        "left"
      ),
      step(
        '[data-ew-tour="flows-edit"]',
        "flows.steps.edit.title",
        "flows.steps.edit.body",
        mediaAt(media, 5),
        { requiresSelector: '[data-ew-tour="flows-edit"]' },
        "left"
      ),
      step(
        "body",
        "flows.steps.done.title",
        "flows.steps.done.body",
        mediaAt(media, 6),
        {},
        "center"
      ),
    ]),
  ];
}

export const TOUR_REGISTRY: Record<ProductTourId, TourDefinition> = {
  flows: {
    id: "flows",
    intro: {
      titleKey: "flows.intro.title",
      bodyKeys: ["flows.intro.body1", "flows.intro.body2"],
      media: img(flowsIntro),
    },
    segments: flowSegments([
      img(flows1),
      img(flows2),
      img(flows3),
      img(flows4),
      img(flows1),
      img(flows2),
      img(flows3),
    ]),
  },
  popups: {
    id: "popups",
    intro: {
      titleKey: "popups.intro.title",
      bodyKeys: ["popups.intro.body1", "popups.intro.body2"],
      media: img(popupsIntro),
    },
    segments: [
      segment("/popups", [
        step(
          '[data-ew-tour="popups-list"]',
          "popups.steps.list.title",
          "popups.steps.list.body",
          img(popups1),
          { eyebrowKey: "common.eyebrow", requiresSelector: '[data-ew-tour="popups-list"]' }
        ),
        step(
          '[data-tut="reactour__popup_add_button"]',
          "popups.steps.create.title",
          "popups.steps.create.body",
          img(popups2),
          { requiresSelector: '[data-tut="reactour__popup_add_button"]' }
        ),
        step(
          '[data-ew-tour="popups-metrics"]',
          "popups.steps.metrics.title",
          "popups.steps.metrics.body",
          img(popups3),
          { requiresSelector: '[data-ew-tour="popups-metrics"]' }
        ),
      ]),
      {
        route: "/popups",
        resolveRoute: popupEditorRoute,
        steps: [
          step(
            '[data-ew-tour="popup-look"]',
            "popups.steps.look.title",
            "popups.steps.look.body",
            img(popups4),
            {
              activateSelector: '[data-ew-tour="popup-look"]',
              requiresSelector: '[data-ew-tour="popup-look"]',
            },
            "right"
          ),
          step(
            '[data-ew-tour="popup-form"]',
            "popups.steps.form.title",
            "popups.steps.form.body",
            img(popups5),
            {
              activateSelector: '[data-ew-tour="popup-form"]',
              requiresSelector: '[data-ew-tour="popup-form"]',
            },
            "right"
          ),
          step(
            '[data-ew-tour="popup-button"]',
            "popups.steps.button.title",
            "popups.steps.button.body",
            img(popups1),
            {
              activateSelector: '[data-ew-tour="popup-button"]',
              requiresSelector: '[data-ew-tour="popup-button"]',
            },
            "right"
          ),
          step(
            '[data-ew-tour="popup-text"]',
            "popups.steps.text.title",
            "popups.steps.text.body",
            img(popups2),
            {
              activateSelector: '[data-ew-tour="popup-text"]',
              requiresSelector: '[data-ew-tour="popup-text"]',
            },
            "right"
          ),
          step(
            '[data-ew-tour="popup-triggers"]',
            "popups.steps.triggers.title",
            "popups.steps.triggers.body",
            img(popups3),
            {
              activateSelector: '[data-ew-tour="popup-triggers"]',
              requiresSelector: '[data-ew-tour="popup-triggers"]',
            },
            "right"
          ),
          step(
            '[data-ew-tour="popup-size-position"]',
            "popups.steps.size.title",
            "popups.steps.size.body",
            img(popups4),
            { requiresSelector: '[data-ew-tour="popup-size-position"]' },
            "left"
          ),
          step(
            ".popup-editor-unified-header__save",
            "popups.steps.save.title",
            "popups.steps.save.body",
            img(popups5),
            { requiresSelector: ".popup-editor-unified-header__save" },
            "left"
          ),
        ],
      },
    ],
  },
  reviews: {
    id: "reviews",
    intro: {
      titleKey: "reviews.intro.title",
      bodyKeys: ["reviews.intro.body1", "reviews.intro.body2"],
      media: img(reviewsIntro),
    },
    segments: [
      segment("/reviews", [
        step(
          '[data-tut="reactour__review_enable"]',
          "reviews.steps.enable.title",
          "reviews.steps.enable.body",
          img(reviews1),
          { eyebrowKey: "common.eyebrow", requiresSelector: '[data-tut="reactour__review_enable"]' }
        ),
        step(
          '[data-ew-tour="reviews-list"]',
          "reviews.steps.list.title",
          "reviews.steps.list.body",
          img(reviews2),
          { requiresSelector: '[data-ew-tour="reviews-list"]' }
        ),
      ]),
      segment("/reviews/settings", [
        step(
          '[data-ew-tour="reviews-look"]',
          "reviews.steps.look.title",
          "reviews.steps.look.body",
          img(reviews3),
          { requiresSelector: '[data-ew-tour="reviews-look"]' }
        ),
        step(
          '[data-ew-tour="reviews-button"]',
          "reviews.steps.button.title",
          "reviews.steps.button.body",
          img(reviews4),
          {
            activateSelector: '[data-ew-tour="reviews-button"]',
            requiresSelector: '[data-ew-tour="reviews-button"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="reviews-popup"]',
          "reviews.steps.popup.title",
          "reviews.steps.popup.body",
          img(reviews5),
          {
            activateSelector: '[data-ew-tour="reviews-popup"]',
            requiresSelector: '[data-ew-tour="reviews-popup"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="reviews-rating-texts"]',
          "reviews.steps.ratingTexts.title",
          "reviews.steps.ratingTexts.body",
          img(reviews1),
          {
            activateSelector: '[data-ew-tour="reviews-rating-texts"]',
            requiresSelector: '[data-ew-tour="reviews-rating-texts"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="reviews-save"]',
          "reviews.steps.save.title",
          "reviews.steps.save.body",
          img(reviews2),
          { requiresSelector: '[data-ew-tour="reviews-save"]' },
          "left"
        ),
      ]),
    ],
  },
  chats: {
    id: "chats",
    intro: {
      titleKey: "chats.intro.title",
      bodyKeys: ["chats.intro.body1", "chats.intro.body2"],
      media: img(chatsIntro),
    },
    segments: [
      segment("/chats", [
        step(
          '[data-ew-tour="chats-inbox-list"]',
          "chats.steps.inbox.title",
          "chats.steps.inbox.body",
          img(chats1),
          { eyebrowKey: "common.eyebrow", requiresSelector: '[data-ew-tour="chats-inbox-list"]' }
        ),
        step(
          '[data-ew-tour="chats-composer"]',
          "chats.steps.composer.title",
          "chats.steps.composer.body",
          img(chats2),
          { requiresSelector: '[data-ew-tour="chats-composer"]' }
        ),
        step(
          '[data-ew-tour="chats-customer-detail"]',
          "chats.steps.customerDetail.title",
          "chats.steps.customerDetail.body",
          img(chats3),
          { requiresSelector: '[data-ew-tour="chats-customer-detail"]' }
        ),
      ]),
      segment("/chats/settings", [
        step(
          '[data-ew-tour="chats-overview"]',
          "chats.steps.overview.title",
          "chats.steps.overview.body",
          img(chats4),
          { requiresSelector: '[data-ew-tour="chats-overview"]' }
        ),
        step(
          '[data-ew-tour="chats-appearance"]',
          "chats.steps.appearance.title",
          "chats.steps.appearance.body",
          img(chats5),
          { requiresSelector: '[data-ew-tour="chats-appearance"]' }
        ),
        step(
          '[data-ew-tour="chats-icon-position"]',
          "chats.steps.iconPosition.title",
          "chats.steps.iconPosition.body",
          img(chats1),
          { requiresSelector: '[data-ew-tour="chats-icon-position"]' }
        ),
        step(
          '[data-ew-tour="chats-behavior"]',
          "chats.steps.behavior.title",
          "chats.steps.behavior.body",
          img(chats2),
          { requiresSelector: '[data-ew-tour="chats-behavior"]' }
        ),
        step(
          '[data-ew-tour="chats-notifications"]',
          "chats.steps.notifications.title",
          "chats.steps.notifications.body",
          img(chats3),
          { requiresSelector: '[data-ew-tour="chats-notifications"]' }
        ),
        step(
          '[data-ew-tour="chats-ai"]',
          "chats.steps.ai.title",
          "chats.steps.ai.body",
          img(chats4),
          { requiresSelector: '[data-ew-tour="chats-ai"]' }
        ),
      ]),
    ],
  },
  wishlists: {
    id: "wishlists",
    intro: {
      titleKey: "wishlists.intro.title",
      bodyKeys: ["wishlists.intro.body1", "wishlists.intro.body2"],
      media: img(wishlistsIntro),
    },
    segments: [
      segment("/wishlists", [
        step(
          '[data-ew-tour="wishlists-sessions"]',
          "wishlists.steps.sessions.title",
          "wishlists.steps.sessions.body",
          img(wishlists1),
          { eyebrowKey: "common.eyebrow", requiresSelector: '[data-ew-tour="wishlists-sessions"]' }
        ),
      ]),
      segment("/wishlists/settings", [
        step(
          '[data-ew-tour="wishlists-overview"]',
          "wishlists.steps.overview.title",
          "wishlists.steps.overview.body",
          img(wishlists2),
          { requiresSelector: '[data-ew-tour="wishlists-overview"]' }
        ),
        step(
          '[data-ew-tour="wishlists-storefront-icon"]',
          "wishlists.steps.storefrontIcon.title",
          "wishlists.steps.storefrontIcon.body",
          img(wishlists3),
          {
            activateSelector: '[data-ew-tour="wishlists-storefront-icon"]',
            requiresSelector: '[data-ew-tour="wishlists-storefront-icon"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="wishlists-customer-account"]',
          "wishlists.steps.customerAccount.title",
          "wishlists.steps.customerAccount.body",
          img(wishlists4),
          {
            activateSelector: '[data-ew-tour="wishlists-customer-account"]',
            requiresSelector: '[data-ew-tour="wishlists-customer-account"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="wishlists-navigation-badge"]',
          "wishlists.steps.navigationBadge.title",
          "wishlists.steps.navigationBadge.body",
          img(wishlists5),
          {
            activateSelector: '[data-ew-tour="wishlists-navigation-badge"]',
            requiresSelector: '[data-ew-tour="wishlists-navigation-badge"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="wishlists-display-rules"]',
          "wishlists.steps.displayRules.title",
          "wishlists.steps.displayRules.body",
          img(wishlists1),
          {
            activateSelector: '[data-ew-tour="wishlists-display-rules"]',
            requiresSelector: '[data-ew-tour="wishlists-display-rules"]',
          },
          "left"
        ),
        step(
          '[data-ew-tour="wishlists-save"]',
          "wishlists.steps.save.title",
          "wishlists.steps.save.body",
          img(wishlists2),
          { requiresSelector: '[data-ew-tour="wishlists-save"]' },
          "left"
        ),
      ]),
    ],
  },
  campaign: {
    id: "campaign",
    intro: {
      titleKey: "campaign.intro.title",
      bodyKeys: ["campaign.intro.body1", "campaign.intro.body2"],
      media: img(campaignIntro),
    },
    segments: [
      segment("/email/campaigns/create", [
        step(
          '[data-ew-tour="campaign-create-types"]',
          "campaign.steps.type.title",
          "campaign.steps.type.body",
          img(campaign1),
          { eyebrowKey: "common.eyebrow", requiresSelector: '[data-ew-tour="campaign-create-types"]' }
        ),
      ]),
      {
        route: "/email/campaigns",
        resolveRoute: latestCampaignDraftRoute,
        steps: [
          step(
            '[data-ew-tour="campaign-wizard-recipients"]',
            "campaign.steps.recipients.title",
            "campaign.steps.recipients.body",
            img(campaign2),
            { requiresSelector: '[data-ew-tour="campaign-wizard-recipients"]' }
          ),
          step(
            '[data-ew-tour="campaign-wizard-setup"]',
            "campaign.steps.setup.title",
            "campaign.steps.setup.body",
            img(campaign3),
            { requiresSelector: '[data-ew-tour="campaign-wizard-setup"]' }
          ),
          step(
            '[data-ew-tour="campaign-wizard-template"]',
            "campaign.steps.template.title",
            "campaign.steps.template.body",
            img(campaign4),
            { requiresSelector: '[data-ew-tour="campaign-wizard-template"]' }
          ),
          step(
            '[data-ew-tour="campaign-wizard-confirm"]',
            "campaign.steps.confirm.title",
            "campaign.steps.confirm.body",
            img(campaign5),
            { requiresSelector: '[data-ew-tour="campaign-wizard-confirm"]' }
          ),
        ],
      },
    ],
  },
};

export const TOUR_PLACEHOLDER_MEDIA: TourMedia = img(placeholder);

export function getTourDefinition(tourId: ProductTourId): TourDefinition {
  return TOUR_REGISTRY[tourId];
}
